/*
    Global Wrapper
    --------------
    Wraps the global context, returning the appropriate object for the platform.
*/

/* eslint-disable */
module.exports = window || global
